export class LikePostModel {
    sourceId: string | undefined;
    sourceType: string | undefined;
    userId: string | undefined;
    reactionType: ReactionType | undefined;
    postId: string | undefined;
}

export enum ReactionType {
    Like = "like",
    Heart = "heart",
    Appreciated = "appreciated",
    Kiss = "kiss",
    ALLGREEN = 'allgreen',
    ANGRYBULL = 'angrybull',
    BLOODBATH = 'bloodbath',
    CRAPMINE = 'crapmine',
    CRASHINGDOWN = 'crashingdown',
    CRYPTOMARKET = 'cryptomarket',
    DEADWEIGHT = 'deadweight',
    DIAMONDHAND = 'diamondhand',
    DOWNCHART = 'downchart',
    FEELINGSICK = 'feelingsick',
    GOLDMINE = 'goldmine',
    KINGOFTHEMARKET = 'kingofthemarket',
    QUEENOFTHEMARKET = 'queenofthemarket',
    SANDBULL = 'sadbull',
    SHOCK = 'shock',
    SHOCKED = 'shocked',
    SMIRKINGBULL = 'smirkingbull',
    TOTHEMOOD = 'tothemood',
    UPCHART = 'upchart'
}